import Swiper,  {
 Pagination
} from 'swiper';

$(document).on('ready', function () {

    const sectionCollectionSideCarousel = $('.section-collection-side-carousel');

    if (!!$(sectionCollectionSideCarousel) == true) {
        $(sectionCollectionSideCarousel).each(function (index, slider) {
            const id = $(slider).attr('data-section-id');
            const carousel_selector = '.section-' + id + ' .swiper';
            const pagination_selector =  '.section-' + id + ' .swiper-pagination';

            var swiper = new Swiper(carousel_selector, {
                slidesPerView: 1,
                loop: true,
                modules:[ Pagination ],
                pagination: {
                    el: pagination_selector,
                    clickable: true
                }
            });
        });
    }
});
